<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
        <el-badge
          v-if="allow('S')"
          :value="checkedCount"
          class="clearable-button"
          :class="{ clearable: !!checkedCount }"
        >
          <b-button
            size="sm"
            variant="outline-primary"
            class="clearable-button ml-2"
            :class="{ clearable: !!checkedCount }"
            :disabled="!checkedCount"
            @click="sendWarehouse"
          >
            {{ $l('btn_sendWarehouse') || '通知送仓' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true, checkedRow: [] }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomHxFtyNoticeInListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-hxBiz-hxFtyInvInNotice-detail',
        params: { ...params, pageType },
        query,
      })
    },
    async sendWarehouse() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_sendWarehouse') || '是否要进行通知送仓操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const hxFtyNoticeInCodeList = this.checkedRow.map(
        (row) => row.hxFtyNoticeInCode
      )
      const res = await this.$api
        .ecomHxFtyNoticeInSendWarehouseApi({
          hxFtyNoticeInCodeList: hxFtyNoticeInCodeList,
        })
        .catch(() => null)
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('通知失败！')
        return
      }
      this.$refs.header.query()
      this.clearCheckboxRow()
      this.$message({ showClose: true, message: '通知成功！', type: 'success' })
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
